const headerMainContentHeightMobileNum = 48;
const headerQuickSearchHeightMobileNum = 52;

export const headerMainContentHeightMobile = `${headerMainContentHeightMobileNum}px`;
export const headerQuickSearchHeightMobile = `${headerQuickSearchHeightMobileNum}px`;
export const headerHeight = '145px';
export const headerHeightMobile =
  headerMainContentHeightMobileNum + headerQuickSearchHeightMobileNum + 'px';
